import { gql } from "@apollo/client";

export const SEARCH_PATIENTS_QUERY = gql`
  query SearchPatients($searchTerm: String, $limit: Int, $offset: Int)
  @permission(requires: useWebApp)
  {
    searchPatient(searchTerm: $searchTerm, limit: $limit, offset: $offset) {
      patient {
        id
        firstName
        lastName
        phone
        dateOfBirth
        sex
      }
      bestEpisode {
        active
        createdAt
        updatedAt
      }
    }
  }
`;
